// Kontostand-Anzeige des Token-Kontingents (Patric 03.10.2026):
// - Saldo >= 0: Balken zeigt den REST, Skala links 0, rechts Kontingentwert; er leert sich von
//   links nach rechts (Fuellung haengt rechts).
// - Saldo < 0: Skala links -MINUS_LIMIT_MIO, rechts 0; rote Fuellung waechst von rechts nach
//   links. Voll = Grenze erreicht. Keine Sperre, nur Hinweis (Standing-Entscheidung 01.10.2026).
// Die Grenze ist eine feste Konstante, nicht pro Kunde einstellbar.
export const MINUS_LIMIT_MIO = 50

export interface TokenAccountView {
  mode: 'credit' | 'debit'
  /** Fuellung des Balkens in Prozent der Breite (0-100) */
  fillPercent: number
  /** Saldo in Mio Token, mit Vorzeichen */
  balanceMio: number
  /** Minus hat die Grenze erreicht oder unterschritten */
  limitReached: boolean
}

export function tokenAccountView(verbleibendMio: number, gesamtMio: number): TokenAccountView {
  if (verbleibendMio < 0) {
    const debtMio = -verbleibendMio
    return {
      mode: 'debit',
      fillPercent: Math.min((debtMio / MINUS_LIMIT_MIO) * 100, 100),
      balanceMio: verbleibendMio,
      limitReached: debtMio >= MINUS_LIMIT_MIO,
    }
  }
  const fillPercent = gesamtMio > 0 ? Math.min(Math.max((verbleibendMio / gesamtMio) * 100, 0), 100) : 0
  return { mode: 'credit', fillPercent, balanceMio: verbleibendMio, limitReached: false }
}

/** "6,9 Mio Token" / "250k Token" / "100 Token": Betrag in Mio IT-SCE-Token fuer die Anzeige (ohne Vorzeichen).
 *  Unter 1000 Token exakte Zahl, nie aufrunden (Anzeige = Buchung). */
export function formatMioTokens(mio: number): string {
  const tokens = Math.abs(mio) * 1_000_000
  if (tokens === 0) return '0 Token'
  if (tokens >= 1_000_000) {
    const rounded = Math.round((tokens / 1_000_000) * 10) / 10
    const str = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1).replace('.', ',')
    return `${str} Mio Token`
  }
  if (tokens >= 1000) return `${Math.round(tokens / 1000)}k Token`
  return `${Math.round(tokens)} Token`
}
